import React from 'react';
import styled from 'styled-components';
import { Grid, Type } from '../../../app/StyleGuide';
import {
  GAUGE_SEGMENT_COUNT,
  getScoreLevelForGaugeSegment,
  SCORE_COLORS,
  scoreToProgressPercent,
} from '../utils/scoreUtils';

const SEGMENT_GAP = Grid._1;

const BarWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${Grid._3};
`;

const SegmentTrack = styled.div`
  display: flex;
  gap: ${SEGMENT_GAP};
  width: 100%;
  height: ${Grid._4};
`;

const Segment = styled.div<{ $color: string }>`
  flex: 1;
  min-width: 0;
  height: 100%;
  border-radius: 999px;
  background: ${props => props.$color};
`;

const ScoreMarker = styled.div<{ $leftPercent: number }>`
  position: absolute;
  top: 0;
  left: ${props => props.$leftPercent}%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid ${Type.Color.dark};
`;

type AssessmentReportScoreSegmentBarProps = {
  score: number;
};

export const AssessmentReportScoreSegmentBar = ({ score }: AssessmentReportScoreSegmentBarProps) => {
  const markerPercent = scoreToProgressPercent(score);

  return (
    <BarWrapper aria-hidden="true">
      <ScoreMarker $leftPercent={markerPercent} />
      <SegmentTrack>
        {Array.from({ length: GAUGE_SEGMENT_COUNT }, (_, index) => {
          const segment = index + 1;
          const segmentLevel = getScoreLevelForGaugeSegment(segment);
          return <Segment key={segment} $color={SCORE_COLORS[segmentLevel]} />;
        })}
      </SegmentTrack>
    </BarWrapper>
  );
};

export default AssessmentReportScoreSegmentBar;
